export class GoogleSigninHelper {

    public static tokenClient: google.accounts.oauth2.TokenClient;

    // /**
    //  * api: https://developers.google.com/identity/gsi/web/reference/html-reference#data-context
    //  * @param dataContext 
    //  */
    public static loadGoogleSigninScriptLabel() {
        const url = 'https://accounts.google.com/gsi/client';
        const locale = "en_US";
        const queryString = `?hl=${locale}`;
        const script = document.createElement('script');

        script.type = 'text/javascript';
        script.src = url + queryString;
        script.async = true;
        script.defer = true;

        document.body.appendChild(script);
    }
}

/* 
 * demo tutorial: https://www.wfublog.com/2023/02/google-people-api-2023.html
*/
// 载入 gsi sdk
// $.getScript("https://accounts.google.com/gsi/client", function() {
//     tokenClient = google.accounts.oauth2.initTokenClient({
//         client_id: client_id,
//         scope: scope,
//         callback: signIn_callback,
//         error_callback: error_callback
//     });
// });